import { render, staticRenderFns } from "./fhir-codeable-concept.vue?vue&type=template&id=beac49a6&"
import script from "./fhir-codeable-concept.vue?vue&type=script&lang=js&"
export * from "./fhir-codeable-concept.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports